import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";

import AuthContextProvider from "./context/authContext";

ReactDOM.render(<AuthContextProvider>
  <BrowserRouter>
    <App />
  </BrowserRouter>
</AuthContextProvider>,
  document.getElementById('root')
);

serviceWorker.unregister();
